import script from './input.vue_vue_type_script_lang.mjs';
export { default } from './input.vue_vue_type_script_lang.mjs';
import { render } from './input.vue_vue_type_template_id_3290dcb6_lang.mjs';

script.render = render;
script.__file = "packages/components/input/src/input.vue";
//# sourceMappingURL=input2.mjs.map
